const vn = {
    type: 'vn',
    name: 'Vietnamese',
    navBar: {
        templates: 'Templates',
        privacy: 'Quyền riêng tư',
        terms: 'Điều khoản',
        signin: 'Đăng nhập',
        signup: 'Đăng ký',
    },
    nfc: {
        title: 'Sử dụng NFC - Công nghệ Giao tiếp Tầm ngắn',
        one: 'Thẻ sử dụng công nghệ NFC để giao tiếp với các thiết bị tương thích khi được đưa lại gần nhau.',
        two: 'Các thẻ này có thể lưu trữ và truyền tải một lượng dữ liệu nhỏ, chẳng hạn như thông tin liên hệ, liên kết trang web hoặc thông tin thanh toán.',
        three: 'Thẻ NFC không cần pin và thường được sử dụng cho danh thiếp kỹ thuật số, kiểm soát ra vào hoặc thanh toán không tiếp xúc.',
    },
    heading: {
        title: 'Nâng tầm Danh thiếp điện tử của bạn',
        des1: 'Tạo hồ sơ của bạn và lưu trên một ',
        desSpan: 'Danh thiếp điện tử',
        des2: ' Chạm thẻ vào điện thoại để xem hồ sơ của bạn tuyệt vời như thế nào',
        button1: 'Tạo tài khoản ngay',
        button2: 'Khám phá templates',
    },
    templates: {
        basic: {
            heading: 'Mẫu Cơ bản',
            des: 'Chỉ cần tạo hồ sơ, mua mẫu bạn chọn và chúng tôi sẽ gửi thẻ cho bạn.',
        },
        pro: {
            heading: 'Mẫu Chuyên nghiệp',
            des: 'Chỉ cần tạo hồ sơ, mua mẫu chuyên nghiệp bạn chọn. Mẫu chuyên nghiệp sẽ hiển thị trên hồ sơ của bạn + thẻ in theo mẫu đó sẽ được gửi cho bạn.',
        },
        diamond: {
            heading: '',
            des: '',
        },
    },
    cards: {
        basic: {
            heading: 'Danh thiếp điện tử Cơ bản',
            des: '',
        },
        professional: {
            heading: 'Danh thiếp điện tử Chuyên nghiệp',
            des: '',
        },
    },
    footer: {
        contactUs: 'Liên hệ chúng tôi ngay',
        faq: 'Câu hỏi phổ biến',
        privacy: 'Quyền riêng tư',
        terms: 'Điều khoản',
        pricing: 'Chính sách thu phí',
        templates: 'Templates',
        signin: 'Đăng nhập',
        signup: 'Đăng ký',
    },
};
export default vn;
